import script from "./AuthenticationError.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthenticationError.vue?vue&type=script&lang=ts&setup=true"

import "./AuthenticationError.vue?vue&type=style&index=0&id=12081e1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12081e1c"]])

export default __exports__